<template>
  <div>
    <v-layout wrap class="mb-4">
      <v-flex xs9 style="display: flex;">
        <img src="/static/img/assets/gblogo.svg" style="max-width: 50px; width: 100%" alt />
        <div class="pl-3" style="overflow: auto">
          <h3 class="headline mt-0 " style="">
            {{ $t('GB Prime Credit Card') }}
          </h3>
        </div>
      </v-flex>

      <v-flex xs3 class="text-xs-right">
        <v-btn fab outline small color="primary" v-if="!isEdit" @click="editGB">
          <i class="fa fa-pencil-alt middle"></i>
        </v-btn>
      </v-flex>
    </v-layout>
    <div class="mt-3">
      ระบบรับชำระเงินผ่าน GB Prime ที่ทำให้สามารถชำระเงินผ่านเครดิตและเดบิตการ์ดได้อย่างง่าย
      ซึ่งลูกค้าไม่ต้องแนบหลักฐานการชำระเงิน และยังมาพร้อมกับระบบ Chat2Pay
      ที่ทำให้เปิดบิลผ่านแชทง่ายๆ เพียงพิมพ์หาลูกค้าว่า เปิดบิล ตามด้วยรายละเอียด และ ราคาสินค้า
      ระบบจะส่งลิ้งจ่ายเงินไปให้ลูกค้าทันที สมัครฟรีวันนี้
      <a href="#" target="_blank" rel="noopener noreferrer"> {{ $t('How to use') }}? </a>
    </div>
    <div v-if="loading" class="text-xs-center my-4">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <v-stepper v-model="step" vertical class="elevation-0">
        <v-stepper-step step="1" :complete="step > 1">
          สมัคร GB Prime
        </v-stepper-step>
        <v-stepper-content step="1">
          <div>
            <carousel :items="1" :autoHeight="true" :nav="false">
              <div>
                <img
                  src="/static/img/assets/chat2pay/step1.png"
                  alt
                  class="responsive-img"
                  style="border-radius: 10px; border: 1px solid #eee; max-width: 600px;  width: 100%"
                />
                <p style="margin-top: 15px; margin-bottom: 0">
                  สมัครสมาชิกเพื่อรับเงินผ่าน GB Prime Pay ที่
                  <a
                    href="https://www.gbprimepay.com/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    >https://www.gbprimepay.com/register</a
                  >
                  กรอกข้อมูล และ
                  <span class="primary-color"
                    >ลูกค้าต้องกรอก รหัสอ้างอิง (Ref): "chat2pay" เพื่อได้เรทการชำระเงินแบบพิเศษ
                    (ชำระบัตรเครดิต ค่าธรรมเนียม 2.9% และชำระผ่าน QR Code 0.5%)</span
                  >
                  หลังจากนั้นรอ 1-3 วัน และเข้าหน้า Profile เพื่อรับ token
                </p>

                <div class="caption">
                  <p>
                    หมายเหตุ: หากติดปัญหาการสมัครสมาชิกรบกวนโทร +66-2645-3781, +66-2248-6397-99,
                    +6692-436-3481 (24 ชั่วโมง)
                  </p>
                </div>
              </div>
              <div>
                <img
                  src="/static/img/assets/chat2pay/step2.png"
                  alt
                  class="responsive-img"
                  style="border-radius: 10px; border: 1px solid #eee; max-width: 600px;  width: 100%"
                />
                <p style="margin-top: 15px; margin-bottom: 0">
                  นำ token ที่ได้จากหน้า Profile (
                  <a
                    href="https://www.gbprimepay.com/merchant/profile"
                    target="_blank"
                    rel="noopener noreferrer"
                    >https://www.gbprimepay.com/merchant/profile</a
                  >
                  ) และส่ง email เพื่อขอ Secret Key และ Public Key มากรอกที่กล่องด้านล่าง
                  และกดบันทึก
                </p>
              </div>
              <div>
                <img
                  src="/static/img/assets/chat2pay/step3.png"
                  alt
                  class="responsive-img"
                  style="border-radius: 10px; border: 1px solid #eee; max-width: 600px;  width: 100%"
                />
                <p style="margin-top: 15px; margin-bottom: 0">
                  เริ่มต้นใช้งาน Chat2Pay ได้เลย โดยแอดมินเพจพิมพ์หาลูกค้าว่า เปิดบิล
                  ตามด้วยรายละเอียดและราคา ระบบจะส่งลิ้งจ่ายเงินไปให้ลูกค้าทันที
                  <span class="primary-color">เงินจะเข้าบัญชีทุกวันจันทร์ พุธ และศุกร์</span>
                </p>
              </div>
            </carousel>
            <v-btn
              @click="step = 2"
              href="https://www.gbprimepay.com/register"
              target="_blank"
              color="primary"
              depressed
              class="mx-0"
              >{{ $t('Register GB Prime') }}</v-btn
            >
          </div>
        </v-stepper-content>

        <v-stepper-step step="2" :complete="step > 2">
          เชื่อมต่อ Zwiz กับ GB Prime
        </v-stepper-step>

        <v-stepper-content step="2">
          <div class="mb-2" v-if="showCancel">
            <div>
              {{ $t('เปิด/ปิด การใช้งาน GB Prime Credit Card') }}
            </div>
            <div>
              <label
                class="toggle-switch small"
                style="margin-top: 10px;margin-bottom: 10px;vertical-align: bottom;"
              >
                <input
                  :disabled="loading"
                  type="checkbox"
                  :checked="gbprimecredit_status"
                  @change="toggleStatus()"
                />
                <span class="toggle-slider lever round"></span>
              </label>
            </div>
            <div>
              {{ $t('เปิด/ปิด การใช้งาน GB Prime Token') }}
            </div>
            <div>
              <label
                class="toggle-switch small"
                style="margin-top: 10px;margin-bottom: 10px;vertical-align: bottom;"
              >
                <input
                  :disabled="loading"
                  type="checkbox"
                  :checked="gbprime_status"
                  @change="toggleQRStatus()"
                />
                <span class="toggle-slider lever round"></span>
              </label>
            </div>
          </div>

          <div class="mb-2" v-if="!showCancel">
            หลังจากได้รับการยินยันจาก GB Prime แล้ว สามารถนำ Secret Key Public Key และ Token
            มาใส่เพื่อทำการเชื่อมต่อที่นี่
          </div>
          <div class="caption">GB Prime Secret Key</div>
          <div class="form-control" :class="{ 'has-error': errors.has('gbprime_secretkey') }">
            <template v-if="isEdit">
              <input
                type="text"
                v-model="gbprime_secretkey"
                v-validate="'required'"
                name="gbprime_secretkey"
                data-vv-as="Secret Key"
              />
              <span class="text-error" v-if="errors.has('gbprime_secretkey')">{{
                errors.first('gbprime_secretkey')
              }}</span>
            </template>
            <div class="primary--text" v-else>
              {{ gbprime_secretkey ? gbprime_secretkey : '-' }}
            </div>
          </div>

          <div class="caption mt-2">GB Prime Public Key</div>
          <div class="form-control" :class="{ 'has-error': errors.has('gbprime_publickey') }">
            <template v-if="isEdit">
              <input
                type="text"
                v-model="gbprime_publickey"
                v-validate="'required'"
                name="gbprime_publickey"
                data-vv-as="Public Key"
              />
              <span class="text-error" v-if="errors.has('gbprime_publickey')">{{
                errors.first('gbprime_publickey')
              }}</span>
            </template>
            <div class="primary--text" v-else>
              {{ gbprime_publickey ? gbprime_publickey : '-' }}
            </div>
          </div>

          <div class="caption mt-2">GB Prime Token</div>
          <div class="form-control" :class="{ 'has-error': errors.has('gbprime_token') }">
            <template v-if="isEdit">
              <input
                type="text"
                v-model="gbprime_token"
                v-validate="'required'"
                name="gbprime_token"
                data-vv-as="Token"
              />
              <span class="text-error" v-if="errors.has('gbprime_token')">{{
                errors.first('gbprime_token')
              }}</span>
            </template>
            <div class="primary--text" v-else>
              {{ gbprime_token ? gbprime_token : '-' }}
            </div>
          </div>

          <div class="text-xs-center" v-if="isEdit">
            <v-btn color="grey" outline @click="onCancel" v-if="showCancel">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn color="primary" depressed @click="onSave">
              {{ $t('Save') }}
            </v-btn>
          </div>
        </v-stepper-content>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import carousel from 'vue-owl-carousel'
import api from '@/api'
export default {
  data() {
    return {
      step: 1,
      isEdit: false,
      showCancel: true,
      loading: true,
      gbprimecredit_status: null,
      gbprime_secretkey: null,
      gbprime_publickey: null,
      gbprime_status: false,
      gbprime_token: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  components: {
    carousel
  },
  async mounted() {
    this.loading = true
    var response = await this.getgbprimecredit()
    if (response.responsecode == 200 && response.data && response.data.length > 0) {
      this.gbprime_secretkey = response.data[0].gbprime_secretkey
      this.gbprime_publickey = response.data[0].gbprime_publickey
      this.gbprimecredit_status = response.data[0].gbprimecredit_status
      this.gbprime_status = response.data[0].gbprime_status
      this.gbprime_token = response.data[0].gbprime_token
    }
    if (!this.gbprime_secretkey || !this.gbprime_publickey || !this.gbprime_token) {
      this.editGB()
      this.showCancel = false
    } else {
      this.step = 2
    }
    this.loading = false
  },
  methods: {
    editGB() {
      this.isEdit = true
      this.cached_gbprime_secretkey = this.gbprime_secretkey
      this.cached_gbprime_publickey = this.gbprime_publickey
      this.cached_gbprimecredit_status = this.gbprimecredit_status
      this.cached_gbprime_status = this.gbprime_status
      this.cached_gbprime_token = this.gbprime_token
    },
    onCancel() {
      this.isEdit = false
      this.gbprime_secretkey = this.cached_gbprime_secretkey
      this.gbprime_publickey = this.cached_gbprime_publickey
      this.gbprimecredit_status = this.cached_gbprimecredit_status
      this.gbprime_status = this.cached_gbprime_status
      this.gbprime_token = this.cached_gbprime_token
    },
    async toggleQRStatus() {
      var vm = this
      const status = !vm.gbprime_status
      try {
        await vm.savegbprimecredit({
          params: {
            pageid: vm.selectedBot.pageid
          },
          body: {
            gbprimecredit_status: this.gbprimecredit_status,
            gbprime_secretkey: this.gbprime_secretkey,
            gbprime_publickey: this.gbprime_publickey,
            gbprime_status: status,
            gbprime_token: this.gbprime_token
          }
        })
        await this.$store.dispatch('updateBotDetail')
        vm.gbprime_status = status
      } catch (error) {
        console.log(error)
      }
    },
    async toggleStatus() {
      var vm = this
      const status = !vm.gbprimecredit_status
      try {
        await vm.savegbprimecredit({
          params: {
            pageid: vm.selectedBot.pageid
          },
          body: {
            gbprimecredit_status: status,
            gbprime_secretkey: this.gbprime_secretkey,
            gbprime_publickey: this.gbprime_publickey,
            gbprime_status: this.gbprime_status,
            gbprime_token: this.gbprime_token
          }
        })
        await this.$store.dispatch('updateBotDetail')
        vm.gbprimecredit_status = status
      } catch (error) {
        console.log(error)
      }
    },

    async onSave() {
      try {
        if (
          this.gbprime_secretkey != null &&
          this.gbprime_publickey != null &&
          this.gbprimecredit_status == null
        )
          this.gbprimecredit_status = true

        var result = await this.$validator.validateAll()
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        this.loading = true

        await this.savegbprimecredit({
          params: {
            pageid: this.selectedBot.pageid
          },
          body: {
            gbprimecredit_status: this.gbprimecredit_status,
            gbprime_secretkey: this.gbprime_secretkey,
            gbprime_publickey: this.gbprime_publickey,
            gbprime_status: this.gbprime_status,
            gbprime_token: this.gbprime_token
          }
        })
        await this.$store.dispatch('updateBotDetail')

        await this.$swal.fire({
          title: this.$t('Successfully'),
          type: 'success'
        })

        this.cached_gbprime_secretkey = this.gbprime_secretkey
        this.cached_gbprime_publickey = this.gbprime_publickey
        this.cached_gbprimecredit_status = this.gbprimecredit_status
        this.cached_gbprime_status = this.gbprime_status
        this.cached_gbprime_token = this.gbprime_token

        this.isEdit = false
        this.showCancel = true
        this.loading = false
      } catch (error) {}
    },
    getgbprimecredit() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getgbprimecredit({ pageid: vm.selectedBot.pageid }, (error, response) => {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    savegbprimecredit(data) {
      var vm = this
      return new Promise((resolve, reject) => {
        api.savegbprimecredit(data, (error, response) => {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/GbprimePayment.vue